import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/esm/Col";
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import { novos_renovados_segmento_total, alunos_turno_unidade } from "../../services/api";

import Alunos_turma from "./aluno_turma";

const Alunos_novos_renovados_segmento = (props) => {

    const [dataTotal, setDataTotal] = useState([]);
    const [dataTurno, setDataaTurno] = useState([]);

    let data_inicio = props.di;
    let data_fim = props.df;
    let cod_unidade = props.un;

    const fetchData = async () => {
        try {
            const response = await novos_renovados_segmento_total(data_inicio, data_fim, cod_unidade);

            setDataTotal(response);
            console.log("dataTotal", response)
            const response2 = await alunos_turno_unidade(data_inicio, data_fim, cod_unidade, cod_unidade);
            console.log("novos renovados turno", response2)
            setDataaTurno(response2);

        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        console.log("B")
        fetchData();
    }, [data_inicio, data_fim]);

    const convertSegmento = (seg) => {
        switch (seg) {
            case '0-1':
                return 'Mat 1';
            case '0-2':
                return 'Mat 2';
            case '0-3':
                return 'Pré 1';
            case '0-4':
                return 'Pré 2';
            case '1-1':
                return '1º Fund I';
            case '1-2':
                return '2º Fund I';
            case '1-3':
                return '3º Fund I';
            case '1-4':
                return '4º Fund I';
            case '1-5':
                return '5º Fund I';
            case '1-6':
                return '6º Fund II';
            case '1-7':
                return '7º Fund II';
            case '1-8':
                return '8º Fund II';
            case '1-9':
                return '9º Fund II';
            case '2-1':
                return '1ª Médio';
            case '2-2':
                return '2ª Médio';
            case '2-3':
                return '3ª Médio';
            default:
                return seg;
        }
    };
    let dataTotalFiltro = dataTotal.filter(elemento => elemento.unidade === cod_unidade);

    console.log("dataTotalFiltro", dataTotalFiltro);

    let somat2027 = 0; //soma total 27
    let soman2027 = 0; // soma novos 27
    let somanm2027 = 0; // soma novos manhã 2027
    let somant2027 = 0; // soma novos tarde 2027
    let somar2027 = 0; // soma renovados 27
    let somarm2027 = 0; // soma novos manhã 2027
    let somart2027 = 0; // soma novos tarde 2027
    let somat2026 = 0; // soma total 26
    let soman2026 = 0; // soma novos 26
    let somar2026 = 0; // soma renovados 26


    let chartDataSeg = [];

    if (typeof dataTotalFiltro !== 'undefined') {
        chartDataSeg = dataTotalFiltro.map((item, index) => {
            const row = [convertSegmento(item.segmento)];

            // row.push(parseInt(item.nm2026));
            // somanm2026 = somanm2026 + parseInt(item.nm2026);
            // row.push(parseInt(item.nt2026));
            // somant2026 = somant2026 + parseInt(item.nt2026);

            row.push(parseInt(item.n2027));
            soman2027 = soman2027 + parseInt(item.n2027);

            // row.push(parseInt(item.rm2026));
            // somarm2026 = somarm2026 + parseInt(item.rm2026);
            // row.push(parseInt(item.rt2026));
            // somart2026 = somart2026 + parseInt(item.rt2026);

            row.push(parseInt(item.r2027));
            somar2027 = somar2027 + parseInt(item.r2027);
            row.push(parseInt(item.n2027) + parseInt(item.r2027));
            somat2027 = somat2027 + parseInt(item.n2027) + parseInt(item.r2027);
            row.push(parseInt(item.n2026));
            soman2026 = soman2026 + parseInt(item.n2026);
            row.push(parseInt(item.r2026));
            somar2026 = somar2026 + parseInt(item.r2026);
            row.push(parseInt(item.n2026) + parseInt(item.r2026));
            somat2026 = somat2026 + parseInt(item.n2026) + parseInt(item.r2026);
            return row;


        });
    };
    chartDataSeg.unshift(['SEGMENTO', 'N 27', 'R 27', 'T 27', 'N 26', 'R 26', 'T 26']);

    chartDataSeg.push(['TOTAL', soman2027, somar2027, somat2027, soman2026, somar2026, somat2026]);

    console.log("chartDataSeg", chartDataSeg)

    let chartDataTur = [];

    let somaManha = 0;
    let somaTarde = 0;
    let somaNovos = 0;
    let somaReno = 0;
    let soma = 0;

    if (typeof dataTurno !== 'undefined') {
        chartDataTur = dataTurno.map((item, index) => {
            const row = [convertSegmento(item.segmento)];

            row.push(parseInt(item.nm2027));
            somanm2027 = somanm2027 + parseInt(item.nm2027);
            row.push(parseInt(item.rm2027));
            somarm2027 = somarm2027 + parseInt(item.rm2027);

            row.push(parseInt(item.nm2027) + parseInt(item.rm2027));
            somaManha = somaManha + (parseInt(item.nm2027) + parseInt(item.rm2027));

            row.push(parseInt(item.nt2027));
            somant2027 = somant2027 + parseInt(item.nt2027);
            row.push(parseInt(item.rt2027));
            somart2027 = somart2027 + parseInt(item.rt2027);
            row.push(parseInt(item.nt2027) + parseInt(item.rt2027));
            somaTarde = somaTarde + (parseInt(item.nt2027) + parseInt(item.rt2027));

            row.push(parseInt(item.nt2027) + parseInt(item.rt2027) + parseInt(item.nm2027) + parseInt(item.rm2027));
            soma = soma + (parseInt(item.nt2027) + parseInt(item.rt2027) + parseInt(item.nm2027) + parseInt(item.rm2027));

            return row;
        });
    };

    chartDataTur.unshift(['SEGMENTO', 'Nm 27', 'Rm 27', 'T. Manhã', 'Nt 27', 'Rt 27', 'T.Tarde', 'Total']);

    chartDataTur.push(['TOTAL', somanm2027, somarm2027, somaManha, somant2027, somart2027, somaTarde, soma]);


    let formatters2 = [
        {
            type: "ColorFormat",
            column: 1,
            ranges: [
                [0, 20000, "blue", "white"],
            ],
        },
        {
            type: "ColorFormat",
            column: 2,
            ranges: [
                [0, 20000, "blue", "white"],
            ],
        },
        {
            type: "ColorFormat",
            column: 3,
            ranges: [
                [0, 20000, "blue", "white"],
            ],
        },
        {
            type: "ColorFormat",
            column: 4,
            ranges: [
                [0, 20000, "red", "white"],
            ],
        },
        {
            type: "ColorFormat",
            column: 5,
            ranges: [
                [0, 20000, "red", "white"],
            ],
        },
        {
            type: "ColorFormat",
            column: 6,
            ranges: [
                [0, 20000, "red", "white"],
            ],
        },


    ];

    let formattersT = [
        {
            type: "ColorFormat",
            column: 1,
            ranges: [
                [0, 20000, "white", "orange"],
            ],
        },
        {
            type: "ColorFormat",
            column: 2,
            ranges: [
                [0, 20000, "white", "orange"],
            ],
        },
        {
            type: "ColorFormat",
            column: 3,
            ranges: [
                [0, 20000, "white", "orange"],
            ],
        },
        {
            type: "ColorFormat",
            column: 4,
            ranges: [
                [0, 20000, "black", "lightgreen"],
            ],
        },
        {
            type: "ColorFormat",
            column: 5,
            ranges: [
                [0, 20000, "black", "lightgreen"],
            ],
        },
        {
            type: "ColorFormat",
            column: 6,
            ranges: [
                [0, 20000, "black", "lightgreen"],
            ],
        },
        {
            type: "ColorFormat",
            column: 7,
            ranges: [
                [0, 20000, "white", "black"],
            ],
        },

    ];

    const optionsTable = {
        allowHtml: true,

    };

    return (
        <div className="SEGeTUR">
            <Tabs
                defaultActiveKey="Total"
                id="uncontrolled-tab-example"
                className="mb-3"
            >
                <Tab eventKey="Total" title="Comparativo 26-27">
                    <center>
                        <Chart
                            chartType="Table"
                            version="current"
                            width="100%"
                            height="500px"
                            data={chartDataSeg}
                            options={optionsTable}
                            formatters={formatters2}
                        // diffdata={diffdataNovos}
                        />

                    </center>
                </Tab>
                <Tab eventKey="turno" title="Por Turno">
                    <center>
                        <Chart
                            chartType="Table"
                            version="current"
                            width="100%"
                            height="500px"
                            data={chartDataTur}
                            options={optionsTable}
                            formatters={formattersT}
                        // diffdata={diffdataNovos}
                        />

                    </center>
                </Tab>
                <Tab eventKey="turma" title="Por Turma">
                    <Alunos_turma un={cod_unidade} />
                </Tab>

            </Tabs>

            <div className="novos_renovados_segmento">

            </div>

        </div>
    );
};

export default Alunos_novos_renovados_segmento;